// 9fbef606107a605d69c0edbcd8029e5d

export const GLOBAL_COMMON_BROWSE_LABELS = 'global.CommonBrowseLabels';

export const lblCommonOutOfStockCaps = 'lbl_common_outOfStockCaps';
export const lblBestSeller = 'lbl_best_seller';
export const lblBopisInterimSoldoutMessage = 'lbl_bopis_interimSoldoutMessage';
export const lblBrierleyPromoTextGeneric = 'lbl_brierley_promo_text_generic';
export const lblCategoryClickHere = 'lbl_category_clickHere';
export const lblCommonItemSoldOut = 'lbl_common_itemSoldOut';
export const lblCommonNavl2RcommendationTitle = 'lbl_common_navl2RcommendationTitle';
export const lblCommonShopAt = 'lbl_common_shopAt';
export const lblCommonShopOtherBrands = 'lbl_common_shopOtherBrands';
export const lblDeliveryMethod = 'lbl_delivery_method';
export const lblEssentialShoppingBack = 'lbl_essentialShopping_back';
export const lblEssentialShoppingColorNext = 'lbl_essentialShopping_colorNext';
export const lblEssentialShoppingNewSearch = 'lbl_essentialShopping_newSearch';
export const lblEssentialShoppingNext = 'lbl_essentialShopping_next';
export const lblEssentialShoppingStartSearch = 'lbl_essentialShopping_startSearch';
export const lblExtraPercent = 'lbl_extra_percent';
export const lblFit = 'lbl_fit';
export const lblFreeShipping = 'lbl_free_shipping';
export const lblGetItToday = 'lbl_get_it_today';
export const lblHbmDepartment = 'lbl_hbm_department';
export const lblNeedItAsap = 'lbl_need_it_asap';
export const lblNoMinReq = 'lbl_no_min_req';
export const lblNoRushPickUp = 'lbl_no_rush_pick_up';
export const lblPickItUp = 'lbl_pick_it_up';
export const lblPickItUpInStore = 'lbl_pick_it_up_in_store';
export const lblPickUp = 'lbl_pick_up';
export const lblPlpAvailableShip = 'lbl_plp_available_ship';
export const lblPlpCarouselDefaultTitle = 'lbl_plp_carousel_default_title';
export const lblPlpShopAll = 'lbl_plp_shop_all';
export const lblSelectAStore = 'lbl_select_a_store';
export const lblShipIt = 'lbl_ship_it';
export const lblShipToHome = 'lbl_ship_to_home';
export const lblShopSimilar = 'lbl_shop_similar';
export const lblSize = 'lbl_size';
export const lblSizeGuide = 'lbl_size_guide';
export const lblUnavlbl = 'lbl_unavlbl';
export const lblViewFullProductDetails = 'lbl_view_full_product_details';

// Badges label
export const lblNew = 'lbl_new';
export const lblOnlineOnly = 'lbl_online_only';
export const lblGlowInDark = 'lbl_glow_in_dark';
export const lblMatchingFamily = 'lbl_matching_family';
export const lblClearance = 'lbl_clearance';
export const lblFewLeft = 'lbl_few_left';
export const lblTopRated = 'lbl_top_rated';
export const lblMostFavorited = 'lbl_most_favorited';
export const lblPreviouslyPurchased = 'lbl_previously_Purchased';
export const lblOnlineExclusive = 'lbl_online_exclusive';

export const globalCommonBrowseLabels = {
  global: {
    CommonBrowseLabels: {
      [lblCommonOutOfStockCaps]: 'OUT OF STOCK',
      [lblBestSeller]: 'TRENDING NOW',
      [lblBopisInterimSoldoutMessage]:
        'THESE STYLES ARE CURRENTLY UNAVAILABLE AT YOUR LOCAL STORE.#Still interested? Check a different location or order online with free shipping everyday!',
      [lblBrierleyPromoTextGeneric]: '2X POINTS## or ##3X POINTS',
      [lblCategoryClickHere]: 'click here',
      [lblCommonItemSoldOut]: 'THIS ITEM IS SOLD OUT',
      [lblCommonNavl2RcommendationTitle]: 'YOU MAY ALSO LIKE',
      [lblCommonOutOfStockCaps]: 'OUT OF STOCK',
      [lblCommonShopAt]: 'Also Shop',
      [lblCommonShopOtherBrands]: 'More to love - tap to shop our family of brands',
      [lblDeliveryMethod]: 'DELIVERY METHOD',
      [lblEssentialShoppingBack]: '< BACK',
      [lblEssentialShoppingColorNext]: 'FIND YOUR STYLES',
      [lblEssentialShoppingNewSearch]: 'NEW SEARCH >',
      [lblEssentialShoppingNext]: 'NEXT >',
      [lblEssentialShoppingStartSearch]: "'LET'S GET STARTED'",
      [lblExtraPercent]: 'Extra 5% Off',
      [lblFit]: 'FIT',
      [lblFreeShipping]: 'Free shipping',
      [lblGetItToday]: 'Get it today!',
      [lblHbmDepartment]: 'GIRL',
      [lblNeedItAsap]: 'Need it ASAP?',
      [lblNoMinReq]: 'No minimum required',
      [lblNoRushPickUp]: 'No Rush Pickup',
      [lblPickItUp]: 'Pick it up!',
      [lblPickItUpInStore]: 'PICK UP IN STORE',
      [lblPickUp]: 'Pick Up',
      [lblPlpAvailableShip]: 'AVAILABLE FOR SHIP TO HOME',
      [lblPlpCarouselDefaultTitle]: 'SHOP BY CATEGORY',
      [lblPlpShopAll]: 'SHOP ALL',
      [lblSelectAStore]: 'SELECT A STORE',
      [lblShipIt]: 'Ship it!',
      [lblShipToHome]: 'Ship To Home',
      [lblShopSimilar]: 'SHOP SIMILAR',
      [lblSize]: 'SIZE',
      [lblSizeGuide]: 'Size Guide',
      [lblUnavlbl]: 'Unavailable',
      [lblViewFullProductDetails]: 'View Full Product Details',
      [lblNew]: 'NEW',
      [lblOnlineOnly]: 'ONLINE ONLY',
      [lblGlowInDark]: 'GLOW-IN-THE-DARK',
      [lblMatchingFamily]: 'MATCHING FAMILY',
      [lblClearance]: 'CLEARANCE',
      [lblFewLeft]: 'JUST A FEW LEFT!',
      [lblTopRated]: 'Top Rated',
      [lblMostFavorited]: 'Most Favorited',
      [lblPreviouslyPurchased]: 'Previously Purchased',
      [lblOnlineExclusive]: 'ONLINE EXCLUSIVE',
    },
  },
};
